module.exports = __webpack_public_path__ + "static-portal/img/yycj.7a6ef85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/yycj.png
// module id = A9sc
// module chunks = 4